import { makeStyles } from 'tss-react/mui';

const name = 'ChainSubtypeTabs';

export const useChainSubtypeTabsStyles = makeStyles({ name })(() => ({
  root: {
    '&': {
      // borderRadius: theme.shape.borderRadiusMd, // ex 11
    },
  },
}));
